// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"60":"cb167b8030","253":"b36c3b65d2","619":"d342f17f89"}[chunkId] + ".js";
};